angular.module('zc.projects')

.directive 'zcExcludeIpEditor', (ProjectExcludeIp, Meta, BaseProjectCrudEditor, SettingStatus, Devise) ->

  class ExcludeIpEditor extends BaseProjectCrudEditor
    getNewItem: () ->
      return {
        ip: '',
        match_type: 'full'
      }

    link: (scope, element, attrs) ->
      # only this specific functionality
      scope.pageTypes = {}
      scope.newItem = @getNewItem()
      scope.isMaster = Devise.isMaster()
      scope.$watch 'items', (excludeIps) ->
        SettingStatus.updateExcludeIpStatus excludeIps
      , true


  editor = new ExcludeIpEditor(
    ProjectExcludeIp
    Meta
    '/templates/projects.settings/initialization/exclude_ip_editor.html'
  )

  return editor.createDirective()



// WEBPACK FOOTER //
// ./src/zenclerk_modules/projects.settings/initialization/exclude_ip_editor.directive.coffee